// extracted by mini-css-extract-plugin
module.exports = {"author":"author___2IyxQ","date":"date___1hTas"};